/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ReactivateUserDto } from '../models/ReactivateUserDto';
import type { SuspendUserDto } from '../models/SuspendUserDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminUserOperationsService {
    /**
     * Suspend user
     * Suspend a client or expert. Sets account status to suspended, disables booking for experts, and revokes all active refresh tokens.
     * @param id User ID (UUID)
     * @param requestBody
     * @returns any User suspended
     * @throws ApiError
     */
    public static adminUsersControllerSuspendUserV1(
        id: string,
        requestBody: SuspendUserDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/admin/users/{id}/suspend',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Already suspended / invalid reason`,
                404: `User not found`,
            },
        });
    }
    /**
     * Reactivate user
     * Reactivate a suspended client or expert. Clears suspension columns. Expert is_accepting_bookings is NOT auto-restored.
     * @param id User ID (UUID)
     * @param requestBody
     * @returns any User reactivated
     * @throws ApiError
     */
    public static adminUsersControllerReactivateUserV1(
        id: string,
        requestBody: ReactivateUserDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/admin/users/{id}/reactivate',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Not currently suspended`,
                404: `User not found`,
            },
        });
    }
}
